module.exports = __webpack_public_path__ + "static/media/1_1.317e5fae.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Design/img/1_1.jpeg
// module id = 276
// module chunks = 0